/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_LOGINSHIFTS,
  LOAD_MASTER_DEPARTMENT,
  LOAD_MASTER_DESIGNATION,
  LOAD_ROLE,
  LOAD_LOP_SETTING,
  LOAD_MASTER_HOLIDAY,
} from "./constants";

import {
  loadMasterDepartment,
  loadMasterDepartmentSuccess,
  loadMasterDepartmentError,
  loadMasterDesignation,
  loadMasterDesignationSuccess,
  loadMasterDesignationError,
  loadRole,
  loadRoleSuccess,
  loadRoleError,
  loadLoginShifts,
  loadLoginShiftsSuccess,
  loadLoginShiftsError,
  loadLopSetting,
  loadLopSettingSuccess,
  loadLopSettingError,
  loadMasterHoliday,
  loadMasterHolidaySuccess,
  loadMasterHolidayError,
} from "./actions";

import {
  loadDepartmentDetails,
  loadDesignationDetails,
  loadRoleDetails,
  loadLoginShiftDetails,
  loadLopSettingDetails,
  loadMasterHolidayDetails,
} from "./remotes";

function* loadMasterDepartmentDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_MASTER_DEPARTMENT),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadMasterDepartment(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadDepartmentDetails, searchFilter);
        if (result) {
          yield put(loadMasterDepartmentSuccess(result.result));
        }
      } catch (error) {
        yield put(
          loadMasterDepartmentError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadMasterDesignationDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_MASTER_DESIGNATION),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadMasterDesignation(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadDesignationDetails, searchFilter);
        if (result) {
          yield put(loadMasterDesignationSuccess(result.result));
        }
      } catch (error) {
        yield put(
          loadMasterDesignationError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadRoleDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ROLE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadRole(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadRoleDetails, searchFilter);
        if (result) {
          yield put(loadRoleSuccess(result.roles));
        }
      } catch (error) {
        yield put(
          loadRoleError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadLoginShiftDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_LOGINSHIFTS),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadLoginShifts(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadLoginShiftDetails, searchFilter);
        if (result) {
          yield put(loadLoginShiftsSuccess(result.result));
        }
      } catch (error) {
            yield put(
              loadLoginShiftsError(
                (error && error.response && error.response.message) ||
                  "Fetch Records Failed"
              )
            )
      }
    }
  }
}

function* loadLopSettingDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_LOP_SETTING),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadLopSetting(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadLopSettingDetails, searchFilter);
        console.log("result", result);
        if (result) {
          yield put(loadLopSettingSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadLopSettingError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadMasterHolidayDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_MASTER_HOLIDAY),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadMasterHoliday(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadMasterHolidayDetails, searchFilter);
        console.log("result", result);
        if (result) {
          yield put(loadMasterHolidaySuccess(result.result));
        }
      } catch (error) {
            yield put(
              loadMasterHolidayError(
                (error && error.response && error.response.message) ||
                  "Fetch Records Failed"
              )
            )
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadMasterDepartmentDetailsSaga(),
    loadMasterDesignationDetailsSaga(),
    loadRoleDetailsSaga(),
    loadLoginShiftDetailsSaga(),
    loadLopSettingDetailsSaga(),
    loadMasterHolidayDetailsSaga() 
  ]);
}
